import { MainApiService } from './MainApiService';
import { USPTOCategoryService } from './USPTOCategoryService';
import { xVerifyService } from './xVerifyService';
import { TrademarkApiService, TrademarkApiProxy } from './TrademarkApiService';

export {
  MainApiService,
  USPTOCategoryService,
  xVerifyService,
  TrademarkApiService,
  TrademarkApiProxy,
};
